import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = { class: "col-sm-12 d-flex align-items-center p-2 justify-content-center" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0" }
const _hoisted_8 = {
  for: "amount",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "row mt-2" }
const _hoisted_15 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0" }
const _hoisted_16 = {
  for: "address",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_17 = { class: "col-sm-12" }
const _hoisted_18 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_19 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0" }
const _hoisted_20 = {
  for: "expenseType",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_21 = { class: "col-sm-12" }
const _hoisted_22 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_23 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0" }
const _hoisted_24 = {
  for: "expenseComment",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_25 = { class: "col-sm-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountWidget = _resolveComponent("AccountWidget")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_WithdrawalWhitelistModal = _resolveComponent("WithdrawalWhitelistModal")!

  return (_ctx.account)
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_AccountWidget, {
                  "hide-insurance": _ctx.store.getters.isMerchant,
                  "show-icon": "",
                  account: _ctx.account
                }, null, 8, ["hide-insurance", "account"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.amount")) + " ", 1),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.form.amount = _ctx.numberFormatter.formatNumber(_ctx.availableAmount, _ctx.account.sum.subunit)), ["prevent"]))
                  }, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.availableAmount, _ctx.account.sum.subunit)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`amount`)
                }, {
                  default: _withCtx((parentProps) => [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.amount) = $event)),
                      class: _normalizeClass([parentProps.class, "form-control"]),
                      type: "text",
                      id: "amount"
                    }, null, 2), [
                      [_vModelText, _ctx.form.amount]
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ]),
              (_ctx.feeAmount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_ctx.settlementData?.fee?.currency === _ctx.settlementData?.usdtFee?.currency)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.helper.trans("labels.withdrawal_fee_warning", {fee: _ctx.numberFormatter.formatNumber(_ctx.feeAmount, 2), feeCurrency: _ctx.fee?.currency})), 1))
                      : (_ctx.settlementData)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_12, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans("labels.withdrawal_rate_warning", {rate: _ctx.numberFormatter.formatNumber(_ctx.settlementData.rate, 2), currency: _ctx.account.currency})), 1),
                            (_ctx.form.amount)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.withdrawal_sum_warning", {sum: _ctx.numberFormatter.formatNumber(_ctx.form.amount ? parseFloat(_ctx.form.amount.replaceAll(" ", '')) : 0, 2), currency: _ctx.account.currency, usdtSum: _ctx.numberFormatter.formatNumber(_ctx.usdtSum, 2)})), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, [
                              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.helper.trans("labels.withdrawal_fee_calc_warning", {usdtFee: _ctx.numberFormatter.formatNumber(_ctx.settlementData?.usdtFee.amount, 2), fee: _ctx.numberFormatter.formatNumber(_ctx.feeAmount, 2), feeCurrency: _ctx.fee?.currency})), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans("labels.address.usdt")), 1),
                (!_ctx.isMerchantOperator)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showWhitelist()), ["prevent"]))
                    }, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.helper.trans("labels.edit_whitelist")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_FormInputWrapper, {
                  errors: _ctx.getErrors(`address`)
                }, {
                  default: _withCtx((parentProps) => [
                    (_ctx.store.getters.getUser?.withdrawalAddress)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.address) = $event)),
                          readonly: "",
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          type: "text",
                          id: "address"
                        }, null, 2)), [
                          [_vModelText, _ctx.form.address]
                        ])
                      : (!_ctx.account.withdrawalWhitelistsEnabled)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.address) = $event)),
                            class: _normalizeClass([parentProps.class, "form-control"]),
                            type: "text",
                            id: "address"
                          }, null, 2)), [
                            [_vModelText, _ctx.form.address]
                          ])
                        : (_openBlock(), _createBlock(_component_Multiselect, {
                            key: 2,
                            class: _normalizeClass([parentProps.class, "multiselect"]),
                            modelValue: _ctx.form.address,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.address) = $event)),
                            options: _ctx.whitelistAddresses,
                            "select-label": "Select",
                            "deselect-label": "",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: false,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "show-no-results": false,
                            "hide-selected": false
                          }, null, 8, ["class", "modelValue", "options"]))
                  ]),
                  _: 1
                }, 8, ["errors"])
              ])
            ]),
            (_ctx.isSystemAccount && _ctx.expenseFieldsEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.helper.trans("labels.expense_type")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`expenseType`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _createVNode(_component_Multiselect, {
                          class: _normalizeClass([parentProps.class, "multiselect"]),
                          modelValue: _ctx.form.expenseType,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.expenseType) = $event)),
                          options: _ctx.expenseTypes,
                          "custom-label": (opt) => _ctx.helper.trans(`expense_type.${opt}`),
                          "select-label": "Select",
                          "open-direction": "bottom",
                          multiple: false,
                          searchable: false,
                          "clear-on-select": true,
                          "close-on-select": true,
                          "show-no-results": false,
                          "allow-empty": true
                        }, null, 8, ["class", "modelValue", "options", "custom-label"])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSystemAccount && _ctx.form.expenseType === _ctx.ExpenseType.OTHER  && _ctx.expenseFieldsEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.helper.trans("labels.expense_comment")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_FormInputWrapper, {
                      errors: _ctx.getErrors(`expenseComment`)
                    }, {
                      default: _withCtx((parentProps) => [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.expenseComment) = $event)),
                          class: _normalizeClass([parentProps.class, "form-control"]),
                          rows: "3",
                          id: "expenseComment"
                        }, "              ", 2), [
                          [_vModelText, _ctx.form.expenseComment]
                        ])
                      ]),
                      _: 1
                    }, 8, ["errors"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors(``)
            }, {
              default: _withCtx((parentProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass(parentProps.class)
                }, null, 2)
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createVNode(_component_WithdrawalWhitelistModal, { ref: "withdrawalWhitelistModal" }, null, 512)
      ]))
    : _createCommentVNode("", true)
}